import React from 'react';
import { Link } from 'react-router-dom';
import './Home.scss';

const Home: React.FC = () => (
  <>
    <main className="home">
      {/* Hero */}
      <section className="hero">
        <img
          src="/hero-bg.png"           // file in /public
          alt=""                        // decorative
          className="hero__bg"
          aria-hidden="true"
        />
        <div className="hero__overlay" aria-hidden="true" />
        <div className="hero__content">
          <h1 className="hero__title">Boostez votre e-réputation avec l'IA</h1>
          <p className="hero__subtitle">
            ReviewBoost AI aide les petites entreprises à gérer, répondre et améliorer
            leurs avis clients.
          </p>
          <Link to="/signup" className="ctaBtn" aria-label="Commencer l'essai gratuit">
            Vous utilisez la version Beta gratuite (PRO)
          </Link>
        </div>
      </section>

      {/* Features */}
      <section className="features">
        <div className="features__container">
          <div className="features__imageWrap">
            <img
              src="/feature.png"
              alt="Aperçu d'un tableau de bord piloté par IA"
              className="features__image"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="features__list">
            <h2>Fonctionnalités Clés de ReviewBoost AI</h2>
            <ul>
              <li>
                <strong>Gestion des Avis</strong><br />
                QR codes et page d’avis publique hébergée — centralisez et répondez, sans connecter Google, Facebook ou Yelp.
              </li>
              <li>
                <strong>Réponses Automatisées par l'IA</strong><br />
                Utilisez une IA avancée pour générer des réponses personnalisées à chaque avis.
              </li>
              <li>
                <strong>Alertes en Temps Réel</strong><br />
                Recevez des notifications instantanées en cas d'avis négatif ou urgent.
              </li>
              <li>
                <strong>Statistiques et Analyse</strong><br />
                Visualisez la répartition des notes, le score de réputation, et améliorez votre stratégie client.
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="pricing">
        <h2 className="pricing__title">Choisissez votre formule</h2>
        <div className="pricing__cards">
          {/* Essai Gratuit */}
          <article className="pricingCard free">
            <div className="cardHeader">
              <div className="pricingTitle">Essai Gratuit</div>
              <div className="pricingPrice">14 jours</div>
            </div>
            <div className="cardFeatures">
              <ul className="pricingFeatures">
                <li><span className="check" aria-hidden>✔</span> Accès complet aux fonctionnalités</li>
                <li><span className="check" aria-hidden>✔</span> 1 emplacement</li>
                <li><span className="check" aria-hidden>✔</span> Support par email</li>
              </ul>
            </div>
          </article>

          {/* Standard */}
          <article className="pricingCard">
            <div className="cardHeader">
              <div className="pricingTitle">Basic</div>
              <div className="pricingPrice">19€/mois</div>
            </div>
            <div className="cardFeatures">
              <ul className="pricingFeatures">
                <li><span className="check" aria-hidden>✔</span> Jusqu'à 3 emplacements</li>
                <li><span className="check" aria-hidden>✔</span> Réponses IA illimitées</li>
                <li><span className="check" aria-hidden>✔</span> Alertes sur avis négatifs</li>
                <li><span className="check" aria-hidden>✔</span> QR codes personnalisés</li>
                <li><span className="check" aria-hidden>✔</span> Support email</li>

              </ul>
            </div>
          </article>

          {/* Pro */}
          <article className="pricingCard">
            <div className="cardHeader">
              <div className="pricingTitle">Pro</div>
              <div className="pricingPrice">39€/mois</div>
            </div>
            <div className="cardFeatures">
              <ul className="pricingFeatures">
                <li><span className="check" aria-hidden>✔</span> Inclut fonctionnalités du plan Basic</li>
                <li><span className="check" aria-hidden>✔</span> Jusqu’à 10 emplacements</li>
                <li><span className="check" aria-hidden>✔</span> Alertes négatives par email</li>
                <li><span className="check" aria-hidden>✔</span> Affiches (logo + QR) PNG/PDF</li>
                <li><span className="check" aria-hidden>✔</span> Statistiques avancés </li>
                <li><span className="check" aria-hidden>✔</span> Support prioritaire</li>
              </ul>
            </div>
          </article>
        </div>
      </section>

      {/* Contacts */}
      <section className="contacts">
        <div className="contacts__grid">

        </div>
      </section>
    </main>
  </>
);

export default Home;
